import React, { useState, useEffect } from "react";
import MDBox from "components/MDBox";
import axios from "axios";
import { Card, Chip, Avatar } from "@mui/material";
import MDTypography from "components/MDTypography";
import { useMaterialUIController } from "context";
import NotificationsIcon from "@mui/icons-material/Notifications";
import ErrorOutlineIcon from "@mui/icons-material/ErrorOutline";
import InfoOutlinedIcon from "@mui/icons-material/InfoOutlined";
import CheckCircleOutlineIcon from "@mui/icons-material/CheckCircleOutline";

function RecentAlerts() {
  const [alerts, setAlerts] = useState([]);
  const [controller] = useMaterialUIController();
  const { darkMode } = controller;

  useEffect(() => {
    const fetchData = async () => {
      try {
        const token = localStorage.getItem("token");

        const response = await axios.get(
          "https://v3.dhundhoo.com/v2/account/alerts?endTime=",
          {
            headers: {
              "x-dhundhoo-session": token,
            },
          }
        );

        setAlerts(response.data);
      } catch (error) {
        console.error("Error fetching alerts:", error);
      }
    };

    fetchData();
  }, []);

  const getAlertMeta = (alert) => {
    switch (alert.type) {
      case "error":
        return { icon: <ErrorOutlineIcon color="error" />, chipColor: "error" };
      case "success":
        return {
          icon: <CheckCircleOutlineIcon color="success" />,
          chipColor: "success",
        };
      case "info":
        return { icon: <InfoOutlinedIcon color="info" />, chipColor: "info" };
      default:
        return {
          icon: <NotificationsIcon color="warning" />,
          chipColor: "warning",
        };
    }
  };

  return (
    <MDBox>
      <Card
        sx={{
          backgroundColor: darkMode ? "#1f283e" : "white",
          borderRadius: "20px",
          boxShadow: "0 2px 6px rgba(0,0,0,0.1)",
          padding: "20px",
          maxHeight: "95vh", // 🔥 limit height
          overflowY: "auto", // 🔥 make scrollable
          // Hide scrollbar for Webkit browsers
          "&::-webkit-scrollbar": {
            display: "none",
          },
          // Hide scrollbar for Firefox
          scrollbarWidth: "none",
          // Hide scrollbar for IE/Edge
          msOverflowStyle: "none",
        }}
      >
        {/* <MDTypography
          variant="h6"
          fontWeight="bold"
          sx={{ mb: 3, color: darkMode ? "white" : "black" }}
        >
          Recent Alerts
        </MDTypography> */}

        {alerts.length === 0 ? (
          <MDTypography variant="body2" color="textSecondary">
            No alerts found.
          </MDTypography>
        ) : (
          alerts.map((alert, index) => {
            const { icon, chipColor } = getAlertMeta(alert);
            return (
              <MDBox
                key={index}
                display="flex"
                justifyContent="space-between"
                alignItems="center"
                sx={{
                  backgroundColor: darkMode ? "#2c3550" : "#f9f9f9",
                  padding: "14px 18px",
                  borderRadius: "14px",
                  mb: 1.5,
                  boxShadow: "0 1px 4px rgba(0,0,0,0.08)",
                  transition: "all 0.2s ease-in-out",
                  "&:hover": {
                    transform: "scale(1.02)",
                    boxShadow: "0 3px 8px rgba(0,0,0,0.15)",
                  },
                }}
              >
                <MDBox display="flex" alignItems="center" gap={1.5}>
                  <Avatar
                    sx={{
                      bgcolor: darkMode ? "#39405a" : "#fff",
                      boxShadow: "0 1px 3px rgba(0,0,0,0.2)",
                    }}
                  >
                    {icon}
                  </Avatar>
                  <MDTypography
                    variant="body1"
                    sx={{
                      fontWeight: 500,
                      whiteSpace: "nowrap",
                      overflow: "hidden",
                      color: darkMode ? "#eee" : "#333",
                    }}
                  >
                    {alert.message || "Untitled Alert"}
                  </MDTypography>
                </MDBox>
                <MDBox display="flex" alignItems="center" gap={1.5}>
                  <Chip
                    label={alert.type || "warning"}
                    size="small"
                    color={chipColor}
                    variant="filled"
                  />
                  <MDTypography
                    variant="caption"
                    sx={{ color: darkMode ? "#bbb" : "#666" }}
                  >
                    {new Date(alert.updatedAt).toLocaleString()}
                  </MDTypography>
                </MDBox>
              </MDBox>
            );
          })
        )}
      </Card>
    </MDBox>
  );
}

export default RecentAlerts;
